import React from "react";
import { useState, useEffect } from 'react';
import { fetchWithAuth } from "../../auth"
import AddCall from "../../dialogs/addCall"

import '../../index.css';

const CallsTableDB = ({
    serial,
    data_bt
}) => {
    const bt_euis = data_bt?.dev.map(obj => obj.eui);
    const bt_names = data_bt?.dev.map(obj => obj.name);
    const [mysqlCallsState, setMysqlCallsState] = useState([]);

    async function fetchcalls() {
        await fetchWithAuth('/calls/' + serial, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                setMysqlCallsState(data)
            })
    }

    useEffect(() => {
        fetchcalls()
    }, [serial]);

    async function deleteCall(event) {
        let _id = event.target.getAttribute('id_arg');
        await fetchWithAuth('/call', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: _id })
        })
        fetchcalls();
    }

    const [openAddCall, setOpenAddCall] = useState(false);
    const handleCloseAddCall = () => {
        setOpenAddCall(false)
        fetchcalls()
    };
    const handleOpenAddCall = () => {
        setOpenAddCall(true)
    };

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <AddCall isOpen={ openAddCall } onClose = { handleCloseAddCall } bt_euis = {bt_euis} bt_names = {bt_names} serial = {serial}/>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px', backgroundColor: 'yellow', color: 'black', fontWeight: 'bold' }}>
                {isOpen ? 'Nascondi Calls' : 'Mostra Calls'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle_db_user" colSpan="3">Chiamate con Sensori</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
                        </tr>
                        <tr>
                            <th className="title">id sensore</th>
                            <th className="title">eui audio (bt)</th>
                            <th className="title">id stanza</th>
                            <th style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={handleOpenAddCall}>Aggiungi</button>
                                <button onClick={fetchcalls}>Aggiorna</button>
                            </th>
                        </tr>
                        {mysqlCallsState.map(mapCall => (
                            <tr key={mapCall.id}>
                                <td>{mapCall.sensor}</td>
                                <td>{mapCall.audio}</td>
                                <td>{mapCall.room}</td>
                                <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                    <button onClick={deleteCall} id_arg={mapCall.id}>elimina</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default CallsTableDB;
